
import utils from 'Utils/utils';

export default function throttle (eventType, callback, threshold) {

	let timePrev = 0;
	let timeCurr = null;
	let timeDiff = null;
	let lastCall = null;

	threshold = utils.checkIf('isNumber', threshold, 250);

	function throttle () {

		timeCurr = (new Date()).getTime();

		timeDiff = timeCurr - timePrev;

		if (timeDiff >= threshold) {

			timePrev = timeCurr;

			callback();

		} else {

			if (lastCall) {

				clearTimeout(lastCall);

			}

			lastCall = setTimeout(throttle, threshold-timeDiff);

		}

	}

	if (utils.isNotEmptyString(eventType) && utils.isFunction(callback)) {

		var eventFn = 0 === threshold ? callback : throttle;

		window.addEventListener(eventType, () => {

			window.requestAnimationFrame(() => {

				eventFn();

			});

		}, false);

	}

}
